export default __webpack_public_path__ + "static/media/bg_help2.dd970136.png";